import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0071a132"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "qrcode" }
const _hoisted_3 = ["src"]



export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  show: Boolean,
  close: Function,
},
  emits: ["close"],
  setup(__props, { emit }) {

const props = __props;



function close() {
  emit("close");
}
function modalContainer(e: Event) {
  // 阻止冒泡
  e.stopPropagation();
}
function maskClose(e: Event) {
  emit("close");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (__props.show)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", {
                class: "modal-wrapper",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (maskClose($event)))
              }, [
                _createElementVNode("div", {
                  class: "modal-container",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (modalContainer($event)))
                }, [
                  _createElementVNode("div", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "qrcode")
                  ]),
                  _createElementVNode("button", {
                    class: "btn-close",
                    onClick: close
                  }, [
                    _createElementVNode("img", {
                      src: require('@/assets/img/index/x.png'),
                      alt: ""
                    }, null, 8, _hoisted_3)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})